export default __webpack_public_path__ + "static/media/fasset_2_2311.26700058.png";